import { STORAGE_BOX_LOCK_LABEL } from '../constants';

export const SHARED_LOCK_OWNER_CRUMB_PREFIX = 'shared-owner:';

export function isSharedLockOwnerCrumbId(crumbId) {
  return typeof crumbId === 'string' && crumbId.startsWith(SHARED_LOCK_OWNER_CRUMB_PREFIX);
}

export function filterLockVaultRootCrumbs(breadcrumbs, lockRootItemId) {
  return (breadcrumbs || []).filter(
    (b) =>
      b.itemId !== lockRootItemId &&
      b.name !== STORAGE_BOX_LOCK_LABEL &&
      b.name !== 'Lock folder'
  );
}

export function buildSharedLockBreadcrumbTrail(activeSharedShare, breadcrumbs, lockRootItemId) {
  const owner = activeSharedShare?.ownerName?.trim() || 'Shared with you';
  const shareId = activeSharedShare?.shareId;
  const tail = filterLockVaultRootCrumbs(breadcrumbs, lockRootItemId).map((b) => ({
    id: b.itemId,
    name: b.name,
  }));
  if (!shareId) return tail;
  return [{ id: `${SHARED_LOCK_OWNER_CRUMB_PREFIX}${shareId}`, name: owner }, ...tail];
}

export function sharedLockPageTitle(activeSharedShare, breadcrumbs, lockRootItemId) {
  const owner = activeSharedShare?.ownerName?.trim() || 'Shared with you';
  const tail = filterLockVaultRootCrumbs(breadcrumbs, lockRootItemId).map((b) => b.name);
  if (!tail.length) return owner;
  return `${owner} / ${tail.join(' / ')}`;
}
